'use client'

export default function LoanImportedBadge({ className = '' }: { className?: string }) {
    return (
        <span
            data-test="imported-badge"
            className={`inline-flex items-center gap-1 rounded-md border border-green-700 bg-green-100 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-green-800 ${className}`}
        >
            <i className="fa-regular fa-check text-[9px]" />
            Importé
        </span>
    )
}
